// src/components/ProgressBar.js

import React from "react";
import "./Footer.css";

function Footer({}) {
  return (
    <>
      <footer>
        <div className="footer-container">
          <a className="copyright">© 2024 Gustavus Adolphus College</a>
          <a href="https://gustavus.edu/feedback/">Feedback</a>
          <a href="https://gustavus.edu/policy/privacy.php">
            Privacy Statement
          </a>
          <a href="https://gustavus.edu/titleix/">Title IX</a>
        </div>
      </footer>
    </>
  );
}

export default Footer;
